import React from 'react'

import Auth0ProviderWrapper from 'auth/providers/Auth0ProviderWrapper'
import { FlagsProvider, FlagsSingleton } from 'flags'
import { createBrowserHistory } from 'history'
import { auth0Settings } from 'lib/config/auth0Settings'
import { Logger } from 'logging'
import { render } from 'react-dom'

import AppWrapper from './components/AppWrapper'
import { LD_CONFIG } from './lib/config'
import flagsAppLevelSubscribes from './lib/config/flagsAppLevelSubscribes'
import flagsLocalDevFlagOverride from './lib/config/flagsLocalDevFlagOverride'
import { isStandaloneMode } from './utils/modeHelper'
import './index.css'

Logger.init()
const history = createBrowserHistory()
const ROOT = 'root'
const standaloneMode = isStandaloneMode()
const init = async () => {
  if (window.parent.__GOOGLE_ANALYTICS_FILTER_PROPERTIES__) {
    const currentPage = `/player/${window.parent.__GOOGLE_ANALYTICS_FILTER_PROPERTIES__.title}`
    Logger.logPageView(currentPage)
  }

  const rootElement = document.getElementById(ROOT)
  const { user, clientSideID } = LD_CONFIG
  FlagsSingleton.initialize({
    clientOptions: {
      user,
      options: {
        application: {
          id: 'player',
        },
      },
      clientID: clientSideID,
    },
    appLevelSubscribedFlags: flagsAppLevelSubscribes,
    localDevFlagOverride: flagsLocalDevFlagOverride,
    restrictFlagEvaluationsToAppLevelSubscribedFlags: true,
  })
  await FlagsSingleton.waitForFlagSystemReady()

  if (window.parent.__CFC_PLAYER_DATA__?.learner) {
    const updatedUserConfigForLaunchDarkly = {
      userEmail: window.parent.__CFC_PLAYER_DATA__.learner,
      roles: ['Teacher'],
    }

    await FlagsSingleton.updateUserContext(updatedUserConfigForLaunchDarkly)
  }

  render(
    <FlagsProvider softReload={true}>
      {standaloneMode ? (
        <div className="auth-wrapper">
          <Auth0ProviderWrapper
            {...auth0Settings}
            history={history}
            className="auth0-provider-wrapper"
          >
            <AppWrapper />
          </Auth0ProviderWrapper>
        </div>
      ) : (
        <AppWrapper />
      )}
    </FlagsProvider>,
    rootElement,
  )
}

init()
